import { useT } from '../../i18n'
import styles from '../note.module.css'

/**
 * What an organisation is on this platform and what this screen can do to
 * one — the same explanatory block the Gateways screen carries, because the
 * two kinds (provider, beneficiary) and the two scope mechanisms (gateways,
 * slices) are the part newcomers get wrong. Open by default; collapsible.
 */
export function BillerNote() {
  const t = useT()
  return (
    <details className={styles.note} open>
      <summary className={styles.summary}>{t('billers.note.title')}</summary>
      <div className={styles.body}>
        <p>{t('billers.note.what')}</p>
        <p>{t('billers.note.provider')}</p>
        <p>{t('billers.note.beneficiary')}</p>
        <p className={styles.key}>{t('billers.note.here')}</p>
        <p>{t('billers.note.users')}</p>
        <p className={styles.caution}>{t('billers.note.fixed')}</p>
      </div>
    </details>
  )
}
